export const analyticsEvents = {
  welcomeQuizStarted: 'Welcome_Quiz_Started', // ✅
  welcomeQuizFinished: 'Welcome_Quiz_Finished', // ✅
  tutorialDisplayed: 'Tutorial_Displayed',
  WTFIsDisplayed: 'WTF_Is_Displayed', // ✅
  WTFIsAction: 'WTF_Is_Action', // ✅
  termsOpened: 'Terms_Opened',
  privacyOpened: 'Privacy_Opened',
  continueWithEmail: 'Continue_With_Email', // ✅
  onboardingEmailEntered: 'Onboarding_Email_Entered', // ✅
  onboardingEmailConfirmed: 'Onboarding_Email_Confirmed', // ✅
  onboardingProfileCompleted: 'Onboarding_Profile_Completed', // ✅
  onboardingAboutMeCompleted: 'Onboarding_About_Me_Completed', // ✅
  onboardingProfilePhotoUploaded: 'Onboarding_Profile_Photo_Uploaded', // ✅
  onboardingNotificationsAllowed: 'Onboarding_Notifications_Allowed',
  quizStarted: 'Quiz_Started', // ✅
  quizQuestionAnswered: (answer: string) => ({
    eventName: 'Quiz_Question_Answered',
    params: {
      action: answer,
    },
  }), // ✅
  quizFinished: 'Quiz_Finished', // ✅
  quizCanceled: 'Quiz_Canceled', // ✅
  quizCalculationClosed: 'Quiz_Calculation_Closed',
  quizCalculationFinished: 'Quiz_Calculation_Finished',
  quizResultsDisplayed: 'Quiz_Results_Displayed', // ✅
  inviteFriendsOpened: 'Invite_Friends_Opened', // ✅
  inviteFriendsInvited: 'Invite_Friends_Invited', // ✅
  userProfileOpened: 'User_Profile_Opened', // ✅
  friendshipRemoved: 'Friendship_Removed', // ✅
  notificationFriendshipApproved: 'Notification_Friendship_Approved', // ✅
  notificationFriendshipRejected: 'Notification_Friendship_Rejected', // ✅
  notificationProfileOpened: 'Notification_Profile_Opened', // ✅
  notificationQuizStarted: 'Notification_Quiz_Started', // ✅
  notificationQuizResults: 'Notification_Quiz_Results', // ✅
  logout: 'Logout', // ✅
  accountRemoved: 'Account_Removed', // ✅
}
